module.exports = __webpack_public_path__ + "static/media/direct_android.5cf7b1aa.png";